export type ISchemaService = ReturnType<typeof schemaServiceFactory>;

/* @ngInject */
export function schemaServiceFactory(eventsService) {
  return {
    getEventsSchema,
  };

  function getEventsSchema() {
    const eventsSchema = [];
    return eventsService.getEvents().then(function(events) {
      for (const event of events) {
        eventsSchema.push(eventSchema(event));
      }
      return eventsSchema;
    });
  }

  function eventSchema(event) {
    const schema = {
      '@context': 'http://schema.org',
      '@type': 'MusicEvent',
      name: event.title,
      image: event.artists[0].image_url, // jshint ignore:line
      startDate: event.datetime,
      url: event.facebook_rsvp_url, // jshint ignore:line
      location: generateLocationSchema(event.venue),
      performer: generateArtistsSchema(event.artists),
      offers: [
        {
          '@type': 'Offer',
          url: event.ticketUrl, // jshint ignore:line
          availability: getTicketAvailability(event.ticketStatus), // jshint ignore:line
          category: 'primary',
        },
      ],
    };
    return schema;
  }

  function generateLocationSchema(venue) {
    const address = {
      '@type': 'PostalAddress',
      addressCountry: venue.country,
      addressLocality: venue.city,
      addressRegion: '',
    };
    if (venue.country === 'United States') {
      address.addressRegion = venue.region;
    }
    const geo = {
      '@type': 'GeoCoordinates',
      latitude: venue.latitude,
      longitude: venue.longitude,
    };
    const location = {
      '@type': 'Place',
      name: venue.name,
      address,
      geo,
    };
    return location;
  }

  function generateArtistsSchema(artists) {
    const performers = [];
    for (const artist of artists) {
      performers.push(generateArtistSchema(artist));
    }
    return performers;
  }

  function generateArtistSchema(artist) {
    const sameAs = [
      artist.siteUrl,
      artist.facebook_page_url,
      artist.facebook_tour_dates_url,
    ]; // jshint ignore:line
    return {
      '@type': 'MusicGroup',
      name: artist.name,
      sameAs,
    };
  }

  function getTicketAvailability(status) {
    const statuses = {
      available: 'InStock',
      unavailable: 'SoldOut',
    };
    return statuses[status];
  }
}
